import { useCallback } from "react";
import { useAppSelector } from "@lemonadetraining/web-shared";
import {
  formatTimeOfDay,
  getDeviceUses24Hour,
  resolveTimeFormat,
  type ResolvedTimeFormat,
  type TimeValue,
} from "../lib/timeFormat";

/**
 * `formatTime` keeps a stable identity while the format is unchanged, so it is
 * safe in a dependency array. Pure helpers take `resolved` instead, which
 * compares by value.
 */
export function useTimeFormat(): {
  resolved: ResolvedTimeFormat;
  formatTime: (value: TimeValue, timeZone: string | null) => string;
} {
  const preference = useAppSelector((state) => state.user.timeFormat);
  const resolved = resolveTimeFormat(preference, { deviceUses24Hour: getDeviceUses24Hour() });
  const formatTime = useCallback(
    (value: TimeValue, timeZone: string | null) => formatTimeOfDay(value, resolved, timeZone),
    [resolved]
  );

  return { resolved, formatTime };
}
